import { createFeatureSelector, createSelector } from '@ngrx/store';
import { adminFeatureKey, AdminState } from '.';

export const selectAdmin = createFeatureSelector<AdminState>(adminFeatureKey);

export const selectStudent = createSelector(selectAdmin, (state: AdminState) => state.student);
